module.exports = __webpack_public_path__ + "images/bimota_small03d30bd8946e20b8e370a4c30e1e3bf2.png";